/* Background panel presentation; the studio remains the owner of design state. */
(() => {
  const icons = {
    none: '<span class="bg-checker-icon"></span>',
    color: '<svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="12"/></svg>',
    pattern: '<svg viewBox="0 0 32 32"><rect x="4" y="4" width="24" height="24" rx="3"/><circle cx="22" cy="10" r="2"/><path d="m5 24 8-10 14 12"/></svg>',
  };
  class BackgroundPanel {
    constructor(ui) {
      this.studio = ui.studio;
      this.panel = ui.root.querySelector('.background-panel');
      const q = s => this.panel.querySelector(s);
      this.color = q('[data-case-bg-color]');
      this.hue = 220;
      const descriptions = {none:['Skaidrus','Matomas telefono dizainas'],color:['Spalva','Pilnas fonas pasirinkta spalva'],pattern:['Paveikslėlis','Naudok mūsų paveikslėlius']};
      q('h2').innerHTML = 'FONAS <span class="bg-info" title="Pasirink skaidrų, spalvotą arba paveikslėlio foną">ⓘ</span>';
      this.panel.querySelectorAll('[data-case-bg-mode]').forEach(button => {
        const mode = button.dataset.caseBgMode;
        button.setAttribute('aria-label', descriptions[mode][0]);
        button.innerHTML = `${icons[mode]}<strong>${descriptions[mode][0]}</strong><small>${descriptions[mode][1]}</small><span class="bg-choice-check" aria-hidden="true">✓</span>`;
      });
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'studio-button is-primary';
      next.dataset.studioTool = 'stickers';
      next.textContent = 'Rinktis lipdukus';
      next.style.cssText = 'width:100%;margin:12px 0;font-size:14px!important;min-height:44px!important';
      q('[data-case-bg-mode]').parentElement.after(next);
      const oldField = this.color.closest('label');
      oldField.hidden = true;
      const section = document.createElement('section');
      section.className = 'bg-color-section';
      section.innerHTML = `<h3>SPALVA <span class="bg-info" title="Spalvą keisk laukelyje arba įvesk HEX ir RGB reikšmes">ⓘ</span></h3>
        <div class="bg-rgb-editor"><div class="bg-color-map"><div class="bg-saturation" role="group" aria-label="Spalvos sodrumas ir šviesumas"><span></span></div><input type="range" min="0" max="359" value="220" data-bg-hue aria-label="Spalvos atspalvis"></div>
        <div class="bg-color-values"><label class="bg-hex"><input data-bg-hex aria-label="Fono HEX spalva" maxlength="7" spellcheck="false"><button type="button" data-bg-copy aria-label="Kopijuoti spalvos kodą" title="Kopijuoti spalvos kodą">⧉</button></label>${['R','G','B'].map((c,i)=>`<label>${c}<input type="number" min="0" max="255" step="1" data-bg-rgb="${i}" aria-label="Fono ${c}"></label>`).join('')}</div></div>
        <div class="swatch-row bg-main-swatches" aria-label="Y2K fono spalvos">${[
          '#ff00ff','#ff1493','#ff3cac','#ff69b4','#bf00ff','#8f00ff','#6600ff','#3300ff',
          '#0047ff','#00a2ff','#00d9ff','#00ffff','#00ffcc','#00ff66','#39ff14','#b6ff00',
          '#e5ff00','#ffff00','#ffcc00','#ff9500','#ff5f1f','#ff3131','#ff537c','#ff8ac6',
          '#ffffff','#000000','#c0c0c0','#e0c3fc','#c3a6ff','#a8d8ff','#baffef','#ffd1f3'
        ].map(c=>`<button type="button" data-bg-swatch="${c}" style="--swatch:${c}" aria-label="${c}" title="${c.toUpperCase()}"></button>`).join('')}</div>
        <label class="bg-opacity">NEPERMATOMUMAS <output>100%</output><input type="range" min="0" max="100" value="100" data-bg-color-opacity aria-label="Fono spalvos nepermatomumas"></label>`;
      oldField.after(section);
      this.panel.querySelector('.swatch-row:not(.bg-main-swatches)').remove();
      const filters = q('.background-library-filters');
      const heading = document.createElement('h3');
      heading.innerHTML = 'PAVEIKSLĖLIAI <span class="bg-info" title="Ieškok pagal pavadinimą arba pasirink kategoriją">ⓘ</span>';
      heading.className = 'bg-images-heading';
      filters.before(heading);
      const categoryLabel = q('[data-bg-category]').closest('label');
      categoryLabel.classList.add('bg-category-select');
      categoryLabel.hidden = true;
      const searchLabel = q('[data-bg-search]').closest('label');
      searchLabel.classList.add('bg-search');
      searchLabel.firstChild.textContent = '';
      q('[data-bg-search]').setAttribute('aria-label','Paieška');
      q('[data-bg-search]').placeholder = 'Ieškoti fonų: flowers, cherries, abstract…';
      const filterButton = document.createElement('button');
      filterButton.type = 'button'; filterButton.className = 'bg-filter-button'; filterButton.dataset.bgFilters = '';
      filterButton.setAttribute('aria-label','Rodyti kategorijų filtrą'); filterButton.setAttribute('aria-expanded','false');
      filterButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h16M8 3v6m8 0v6m-6 0v6"/></svg>';
      filters.append(filterButton,categoryLabel);
      this.chips = document.createElement('div'); this.chips.className = 'bg-category-chips'; this.chips.setAttribute('aria-label','Fonų kategorijos');
      filters.after(this.chips);
      const adjust = document.createElement('details'); adjust.className = 'bg-adjust';
      adjust.innerHTML = '<summary>Paveikslėlio dydis ir padėtis</summary>';
      adjust.append(q('.background-scale-field'),q('[data-bg-resize-toggle]'),q('.background-resize-hint'));
      q('.bg-images-heading').after(adjust);
      const images = document.createElement('section');
      images.className = 'bg-image-section';
      heading.before(images);
      images.append(heading, adjust, filters, this.chips, q('[data-bg-result-count]'), q('[data-pattern-grid]'), q('[data-bg-load-more]'));
      this.panel.addEventListener('click',event=>this.onClick(event));
      this.panel.addEventListener('change',event=>this.onChange(event));
      this.panel.addEventListener('input',event=>{
        if(event.target.matches('[data-bg-hue]')) {this.hue=Number(event.target.value);this.applyHSV(this.saturation ?? 1,this.value ?? 1);}
        if(event.target.matches('[data-bg-color-opacity]')) {
          this.studio.caseBackground.colorOpacity=Number(event.target.value);
          this.studio.caseBackground.type='color';this.studio.updateCaseBackground();this.studio.renderLayerList();this.studio.syncOutput();
        }
      });
      q('[data-bg-color-opacity]').addEventListener('pointerdown',()=>this.studio.pushHistorySnapshot());
      q('[data-bg-color-opacity]').addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End','ArrowUp','ArrowDown'].includes(event.key))this.studio.pushHistorySnapshot();});
      const pad=q('.bg-saturation');
      const move=event=>{const r=pad.getBoundingClientRect();this.applyHSV(Math.max(0,Math.min(1,(event.clientX-r.left)/r.width)),1-Math.max(0,Math.min(1,(event.clientY-r.top)/r.height)));};
      pad.addEventListener('pointerdown',event=>{if(event.button!==0)return;event.preventDefault();pad.setPointerCapture(event.pointerId);this.dragging=event.pointerId;this.studio.pushHistorySnapshot();move(event);});
      pad.addEventListener('pointermove',event=>{if(this.dragging===event.pointerId)move(event);});
      const stop=()=>{this.dragging=null;};pad.addEventListener('pointerup',stop);pad.addEventListener('pointercancel',stop);
      this.sync();
    }
    setColor(hex,history=true) {
      if(!/^#[0-9a-f]{6}$/i.test(hex))return this.sync();
      if(history)this.studio.pushHistorySnapshot();
      this.studio.caseBackground.color=hex.toLowerCase();this.studio.caseBackground.type='color';
      this.studio.updateCaseBackground();this.studio.renderLayerList();this.studio.syncOutput();
    }
    applyHSV(s,v) {
      const h=this.hue/60,c=v*s,x=c*(1-Math.abs(h%2-1)),m=v-c;
      const rgb=h<1?[c,x,0]:h<2?[x,c,0]:h<3?[0,c,x]:h<4?[0,x,c]:h<5?[x,0,c]:[c,0,x];
      this.setColor('#'+rgb.map(n=>Math.round((n+m)*255).toString(16).padStart(2,'0')).join(''),this.dragging==null);
    }
    onChange(event) {
      if(event.target.matches('[data-bg-hex]'))this.setColor('#'+event.target.value.replace(/^#/,''));
      if(event.target.matches('[data-bg-rgb]')) {
        const rgb=[...this.panel.querySelectorAll('[data-bg-rgb]')].map(el=>Math.max(0,Math.min(255,Math.round(Number(el.value)||0))));
        this.setColor('#'+rgb.map(v=>v.toString(16).padStart(2,'0')).join(''));
      }
    }
    onClick(event) {
      const target=event.target.closest('button');if(!target)return;
      if(target.hasAttribute('data-bg-filters')){const label=this.panel.querySelector('.bg-category-select');label.hidden=!label.hidden;target.setAttribute('aria-expanded',String(!label.hidden));}
      if(target.hasAttribute('data-bg-chip')){this.studio.backgroundCategory=target.dataset.bgChip;this.studio.backgroundVisibleCount=60;this.studio.renderPatternGrid();this.sync();}
      if(target.hasAttribute('data-bg-copy'))navigator.clipboard.writeText(this.studio.caseBackground.color.toUpperCase()).then(()=>{this.studio.nodes.status.textContent='Spalvos kodas nukopijuotas.';}).catch(()=>{this.panel.querySelector('[data-bg-hex]').select();});
    }
    sync() {
      const q=s=>this.panel.querySelector(s),bg=this.studio.caseBackground,hex=bg.color||'#ffffff';
      q('.bg-color-section').hidden = bg.type !== 'color';
      q('.bg-image-section').hidden = bg.type !== 'pattern';
      const rgb=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
      const [r,g,b]=rgb.map(v=>v/255),max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;
      if(d)this.hue=((max===r?(g-b)/d+(g<b?6:0):max===g?(b-r)/d+2:(r-g)/d+4)*60);
      this.saturation=max?d/max:0;this.value=max;
      q('.bg-saturation').style.backgroundColor=`hsl(${this.hue} 100% 50%)`;
      q('.bg-saturation span').style.cssText=`left:${this.saturation*100}%;top:${(1-max)*100}%;background:${hex}`;
      q('[data-bg-hue]').value=this.hue;
      q('[data-bg-hex]').value=hex.toUpperCase();
      this.panel.querySelectorAll('[data-bg-rgb]').forEach((el,i)=>el.value=rgb[i]);
      const opacity=bg.colorOpacity??100;q('[data-bg-color-opacity]').value=opacity;q('.bg-opacity output').textContent=`${opacity}%`;
      this.panel.querySelectorAll('[data-case-bg-mode]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.caseBgMode===bg.type)));
      const cats=[...new Set(this.studio.backgroundPatterns.map(p=>p.category||'Custom'))];
      const keys=['All',...cats];
      if(this.categoryKey!==keys.join('|')) {
        this.chips.replaceChildren(...keys.map(key=>{const b=document.createElement('button');b.type='button';b.dataset.bgChip=key;b.textContent=key==='All'?'Visos':key==='Custom'?'Mano fonai':key;return b;}));this.categoryKey=keys.join('|');
      }
      this.chips.querySelectorAll('button').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.bgChip===this.studio.backgroundCategory)));
    }
  }
  window.StrayzyBackgroundPanel=BackgroundPanel;
})();
